export default "__VITE_ASSET__B4PSPhZ9__"